import { render, staticRenderFns } from "./BuyersHome.vue?vue&type=template&id=0e6f92c0&scoped=true&"
import script from "./BuyersHome.vue?vue&type=script&lang=js&"
export * from "./BuyersHome.vue?vue&type=script&lang=js&"
import style0 from "./BuyersHome.vue?vue&type=style&index=0&id=0e6f92c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e6f92c0",
  null
  
)

export default component.exports